import Vue from 'vue';

import loadingComponent from './main.vue';

// 返回一个 扩展实例构造器
let loadingDom;
// 注册为全局组件的函数
function loadingRegistry() {
  // 将组件注册到 vue 的 原型链里去,
  // 弹出框
  const LoadConstructor = Vue.extend(loadingComponent);

  Vue.prototype.showLoading = (object = {}) => {
    const { title, mask = false } = object;
    if (!loadingDom) {
      loadingDom = new LoadConstructor({
        el: document.createElement('div'),
        data() {
          return {
            title,
            mask,
            show: true
          };
        }
      });
      document.body.appendChild(loadingDom.$el);
    } else {
      loadingDom = Object.assign(loadingDom, object, { show: true });
    }
    return loadingDom;
  };
  Vue.mixin({
    methods: {
      hideLoading() {
        if (loadingDom) {
          loadingDom = Object.assign(loadingDom, {
            title: '',
            mask: false,
            show: false
          });
        }
      }
    }
  });
}

export default loadingRegistry;
